import React from 'react';
import { useParams } from 'react-router-dom';
import Objects from '../object/Objects';
import CreateObject from '../object/CreateObject';
import NegHistory from '../object/NegHistory';
import NegReq from '../object/NegReq';
const NegMenu = props => {
  const { section, section_2, id } = useParams();
  const currentTab = () => {
    switch (section) {
      case 'negative-objects':
        return id === 'new' || section_2 === 'collection' || section_2 === 'edit' ? <CreateObject {...props} /> : <Objects {...props} />;
      case 'negative-req':
        return <NegReq {...props} />;
      case 'negative-history':
        return <NegHistory {...props} />;
      default:
        return <Objects {...props} />;
    }
  };
  return <div>{currentTab()}</div>;
};

export default NegMenu;
